<!-- @format -->

<template>
	<div class="">
		<div id="main" class="">
			<div class="card">
				<div class="card-body">
					<h1>{{ filteredMedicine.name }}</h1>
					<div v-for="(s, idx1) in filteredMedicine.mainEntityOfPage" :key="idx1">
						<div v-for="(s2, idx2) in s.mainEntityOfPage" :key="idx2">
							<div v-html="s2.text"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import MedicinesAtoZ from '../../../App_Data/medicines.json';

	export default {
		name: 'Medicine',
		props: ['alias'],
		data() {
			return MedicinesAtoZ;
		},
		computed: {
			filteredMedicine() {
				let letter = this.alias.charAt(0).toUpperCase();
				let list = this.MedicinesAtoZ.filter((m) => {
					return m.Letter.Name.match(letter);
				});
				let med = list[0].Medicines.filter((m) => {
					return m.Alias.match(this.alias);
				});
				console.log(med);
				let obj = JSON.parse(med[0].Detail);
				return obj;
			},
		},
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
